import React, { CSSProperties } from "react";

interface NavbarContainerExportProps {
  children?: React.ReactNode;
  backgroundColor?: string;
  textColor?: string;
  sticky?: boolean;
  maxWidth?: string;
  paddingX?: number;
  paddingY?: number;
  gap?: number;
}

export const NavbarContainerExport: React.FC<NavbarContainerExportProps> = ({
  children,
  backgroundColor = "#ffffff",
  textColor = "#1f2937",
  sticky = true,
  maxWidth = "1280px",
  paddingX = 24,
  paddingY = 12,
  gap = 16,
}) => {
  const navStyles: CSSProperties = {
    width: "100%",
    maxWidth,
    margin: "0 auto",
    padding: `${paddingY}px ${paddingX}px`,
    backgroundColor,
    color: textColor,
    position: sticky ? "sticky" : "relative",
    top: sticky ? 0 : "auto",
    zIndex: 1000,
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: `${gap}px`,
    minHeight: "40px",
    flexWrap: "wrap",
    boxSizing: "border-box",
  };

  return (
    <nav style={navStyles} data-element="navbar" data-type="menu">
      {children}
    </nav>
  );
};
